import numeral from 'numeral'

export const areaLoadForceFormatter = (value: number) => {
  const valueInKilos = value / 1000
  const formatter = '0[.][00]'
  return `${numeral(valueInKilos).format(formatter)}`
}

export const areaLoadForceValueGetter = (force: Force) => {
  // For area loads, the force is already in the correct coordinate system
  // and represents N/m². We are just applying a small threshold to avoid
  // displaying very small values.
  const absForceZ = Math.abs(force.z)
  return absForceZ < 1.0e-3 ? 0 : force.z
}
